<template>
  <div v-if="
    dataUser &&
    dataUser.permissionCodes?.includes('CNPS_AGENT_PARTNER_BANK_LIST')
  ">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách tài khoản</h1>
      <div class="float-right">
        <b-button
         variant="success"
        v-if="
          dataUser &&
          dataUser.permissionCodes?.includes('CNPS_AGENT_PARTNER_BANK_CREATE')
        "  data-toggle="tooltip" data-placement="top"
          @click="$router.push('/agent-bank/add')">
          <i class='bx bx-plus'></i>
          Tạo tài khoản
        </b-button>
      </div>
    </div>
    <div class="pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input type="text" v-model.trim="search.keyword" class="form-control f12 hc-37"
              placeholder="Tên / email TK" />
          </div>
          <div class="form-group">
            <DateRangePicker class="w-100" :ranges="false" @update="transformDate()" v-model="dateRange"
              :locale-data="localeData">
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em"
                  class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 placeholder="Cấp độ" v-model="search.level" :options="levelUerAgentBank">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Tỉnh thành" v-model="search.cityCode" :options="provinceOptions"
              @change="getListDictrict">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Đối tác" v-model="search.partnerCode" :options="partnerCodeMap">
            </Select2>
          </div>
          <div class="form-group" style="position: relative">
            <span style="
                height: 37px;
                position: absolute;
                top: 0;
                right: left;
                z-index: 5;
                width: 200px;
                text-align: left;
                background-color: #dee2e6;
                line-height: 37px;
                border: 1px solid #ced4da;
                padding-left: 10px;
                border-radius: 4px;
              " v-if="loadingDictric">Đang tải...</span>
            <Select2 :placeholder="'Quận huyện'" :disabled="loadingDictric || districtOptions?.length === 0"
              v-model="search.districtCode" :options="districtOptions">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Quản lý" v-model="search.managerId" :options="managerOptions">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 placeholder="Trạng thái" v-model="search.stateAgent" :options="statusOptions">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button @click="submitForm" class="pt-2 mr-2 btn btn-primary hc-37" data-toggle="tooltip"
              data-placement="top" title="Lọc">
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button @click="removeForm" type="button" class="pt-2 mr-2 btn btn btn-outline-light hc-37"
              data-toggle="tooltip" data-placement="top" title="Bỏ lọc">
               <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <strong class="total-label">Tổng: <span class="text-primary">{{ pagination.total | formatNumberVN }}</span></strong>
            <b-table :busy.sync="loading" sticky-header hover responsive :items="list" :fields="filterTable"
              :fixed="true" :bordered="true">
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(name)="{ item }">
                <p>Tên: {{ item.name }}</p>
                <p>Loại: {{ item.typeDigital === 'NORMAL' ? 'Tài khoản tự bán thiết bị' : 'Tài khoản giới thiệu merchant' }}
                </p>
              </template>
              <template #cell(createdDate)="{ item }">
                {{ formatDateTime(item.createdDate) }}
              </template>
              <template #cell(level)="{ item }">
                {{ getLevelName(item.level) }}
              </template>
              <template #cell(address)="{ item }">
                {{ item.address }}
              </template>
              <template #cell(manager)="{ item }">
                {{ item.managerName ? item.managerName : "" }}
                {{ item.managerEmail ? item.managerEmail : "" }}
              </template>
              <template #cell(stateAgent)="{ item }">
                <span class="badge" :class="getStatusClass(item.stateAgent)">
                  {{ getStatusLabel(item.stateAgent) }}
                </span>
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown  variant="outline-primary">
                    <b-dropdown-item v-if="
                  dataUser &&
                  dataUser.permissionCodes?.includes(
                    'CNPS_AGENT_PARTNER_BANK_DETAIL'
                  )
                "  @click="viewDetails(item.id)">
                  Chi tiết
                </b-dropdown-item>
                <b-dropdown-item v-if="
                  dataUser &&
                  dataUser.permissionCodes?.includes(
                    'CNPS_AGENT_PARTNER_BANK_UPDATE'
                  )
                "  @click="updateAccount(item.id)">
                  Cập nhật
                </b-dropdown-item>
                <b-dropdown-item v-if="dataUser &&
    dataUser.permissionCodes?.includes('CNPS_AGENT_PARTNER_BANK_SET_GROUP_PERMISSION')
  " @click="openPermissionModal(item)">
                  Gán quyền
                </b-dropdown-item>
                </b-dropdown>

              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination v-model="search.page" :total-rows="pagination.total" :per-page="search.limit"
          class="mr-2 fl-right"></b-pagination>
      </div>
    </div>
    <!-- Modal Gán Quyền - thêm vào cuối template -->
      <b-modal
        v-model="showPermissionModal"
        :title="`Gán quyền tài khoản: ${ selectedAccount?.name }`"
        size="lg"
        @hide="resetPermissionModal"
      >
        <div v-if="selectedAccount">
          <div class="permission-list" >
            <div class="form-check" v-for="permission in permissionList" :key="permission.code">
              <input
                class="form-check-input"
                type="checkbox"
                :id="permission.code"
                v-model="selectedPermissions"
                :value="permission.code"
              >
              <label class="form-check-label" :for="permission.code">
                <span class="permission-name ml-3">{{ permission?.name }}</span>
              </label>
            </div>
          </div>
        </div>

        <template #modal-footer="{ hide }">
          <b-button variant="secondary" @click="hide()">
            Hủy
          </b-button>
          <b-button variant="primary" @click="savePermissions" :disabled="savingPermissions">
            <b-spinner small v-if="savingPermissions"></b-spinner>
            {{ savingPermissions ? 'Đang lưu...' : 'Lưu' }}
          </b-button>
        </template>
      </b-modal>

    <!-- <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay> -->
  </div>

</template>
<script>
import { CommonService } from '@/services/common.service'
import moment from 'moment'
import Config from '@/thirdParty/config'
// import { levelUerAgentBank } from '../../config/common'

const fieldsTable = [
  { key: 'index', label: 'STT', class: 'text-center', thStyle: { width: '80px' }, tdStyle: { width: '80px' } },
  { key: 'name', label: 'Tên tài khoản' },
  { key: 'createdDate', label: 'Thời gian tạo' },
  { key: 'level', label: 'Cấp độ' },
  { key: 'address', label: 'Địa chỉ' },
  { key: 'manager', label: 'Quản lý' },
  { key: 'partnerCode', label: 'Đối tác' },
  { key: 'stateAgent', label: 'Trạng thái' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]
export default {
  name: 'AccountList',
  components: {},
  data () {
    return {
      loading: false,
      loadingDictric: false,
      showLoading: false,
      fieldsTable,
      filterTable: fieldsTable,
      dataUser: JSON.parse(localStorage.getItem('userData')),
      list: [],
      levelUerAgentBank: [],
      search: {
        page: 1,
        limit: 20
      },
      partnerCodeMap: [],
      dateRange: {
        startDate: null,
        endDate: null
      },
      localeData: Config.localeData,
      pagination: {
        total: 0
      },
      timeOptions: [],
      provinceOptions: [],
      districtOptions: [],
      managerOptions: [],
      statusOptions: [
        { id: 'all', text: 'Tất cả', variant: '' },
        { id: 'ACTIVE', text: 'Hoạt động', variant: 'success' },
        { id: 'LOCKED', text: 'Khoá', variant: 'danger' }
      ],
      // Modal gán quyền
      showPermissionModal: false,
      selectedAccount: null,
      selectedPermissions: [],
      savingPermissions: false,
      permissionList: []
      // Lưu trữ dữ liệu gốc
    }
  },
  async mounted () {
    this.fetchData()
    this.loadUser()
    this.getAgentLevel()
    this.fetchĐataPartner()
    this.getListPermissionData()
  },

  watch: {
    'search.limit': function () {
      this.fetchData()
    },
    'search.page': function () {
      this.fetchData()
    }
  },
  computed: {

    getLevelName () {
      return (level) => {
        const map = this.levelUerAgentBank.reduce((acc, curr) => {
          acc[curr.id] = curr.text
          return acc
        }, {})
        return map[level] || 'level'
      }
    }
  },
  methods: {

    async getListPermissionData () {
      // AI
      try {
        // AI
        const data = await CommonService.getListPermission()

        if (data.code === 1000) {
          // permissionList
          // AI
          this.permissionList = data.data.map((e) => {
            // AI
            return {
              // AI
              code: e.name,
              name: e.description // AI
            } // AI
          })
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
      }
    },
    // Phương thức gán quyền
    openPermissionModal (account) {
      this.selectedAccount = account
      this.selectedPermissions = account.roles ? [...account.roles] : []
      this.showPermissionModal = true
    },

    resetPermissionModal () {
      this.selectedAccount = null
      this.selectedPermissions = []
      this.savingPermissions = false
    },

    async savePermissions () {
      this.savingPermissions = true
      try {
      // Body theo format yêu cầu
        const body = {
          agentIds: [this.selectedAccount.agentId],
          roles: this.selectedPermissions
        }

        // Gọi API với body mới
        const data = await CommonService.updateAccountPermissions(body)
        if (data.code === 1000) {
        // Cập nhật lại data trong list
          const accountIndex = this.list.findIndex(item => item.agentId === this.selectedAccount.agentId)
          if (accountIndex !== -1) {
            this.list[accountIndex].roles = [...this.selectedPermissions]
          }
          this.showSuccessMx(
            'Cập nhật quyền thành công!'
          )
          this.showPermissionModal = false
        }
      } catch (error) {
        this.showFailMx('Cập nhật quyền thất bại: ' + (error.message || error))
      } finally {
        this.savingPermissions = false
      }
    },
    async fetchĐataPartner () {
      try {
        const data = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.partnerCodeMap = data.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: 'all', text: 'Tất cả' })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    async getAgentLevel () {
      // AI
      try {
        // AI
        const data = await CommonService.getAgentLevel()

        if (data.code === 1000) {
          // AI
          this.levelUerAgentBank =
            data.data.map((e) => {
              // AI
              return {
                // AI
                id: e.level,
                text: e.name // AI
              } // AI
            }) || [] // AI
          this.levelUerAgentBank.unshift({ id: 'all', text: 'Tất cả' })
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
      }
    },
    transformDate () {
      this.search.fromDate = moment(this.dateRange.startDate)
        .startOf('day')
        .add(7, 'hours')
        .valueOf()
      this.search.toDate = moment(this.dateRange.endDate)
        .endOf('day')
        .add(7, 'hours')
        .valueOf()
    },
    async submitForm (event) {
      event.preventDefault()
      this.fetchData()
    },
    async removeForm () {
      this.search = {
        limit: 20,
        page: 1,
        keySearch: '',
        createdDate: null,
        level: null,
        cityCode: null,
        districtCode: null,
        managerId: null,
        stateAgent: null
      }
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      await this.fetchData()
    },
    getIndex (index) {
      return (this.search.page - 1) * this.search.limit + index + 1
    },
    viewDetails (id) {
      this.$router.push('/agent-bank/detail/' + id)
    },
    updateAccount (id) {
      this.$router.push('/agent-bank/edit/' + id)
    },

    // Phương thức để định dạng thời gian
    formatDateTime (dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()

      return `${hours}:${minutes}, ${day}/${month}/${year}`
    },

    // Phương thức để lấy label trạng thái
    getStatusLabel (status) {
      const statusOption = this.statusOptions.find(
        (option) => option.id === status
      )
      return statusOption ? statusOption.text : status
    },

    // Phương thức để lấy class CSS cho trạng thái
    getStatusClass (status) {
      const statusOption = this.statusOptions.find(
        (option) => option.id === status
      )
      return statusOption ? `badge-${statusOption.variant}` : ''
    },
    async loadUser () {
      // AI
      try {
        // AI
        const data = await CommonService.getListUserBank({
          // AI
          // level: 2 // AI
        }) // AI
        if (data.success) {
          // AI
          this.managerOptions =
            data.data.map((e) => {
              // AI
              return {
                // AI
                id: e.agentId,
                text: e.name + ' - ' + e.email || '' // AI
              } // AI
            }) || [] // AI
          this.managerOptions.unshift({ id: 'all', text: 'Tất cả' })

          const provinceRes = await CommonService.getProvince({}) // AI
          if (provinceRes.success) {
            // AI
            this.provinceOptions =
              provinceRes.data.map((s) => ({ id: s.code, text: s.name })) || [] // AI
          } // AI
          this.provinceOptions.unshift({ id: 'all', text: 'Tất cả' })
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      }
    },
    async getListDictrict (code) {
      // AI
      this.loadingDictric = true // AI
      try {
        // AI
        const data = await CommonService.getDistrict({ cityCode: code }) // AI
        if (data.success) {
          // AI
          this.districtOptions =
            data.data.map((s) => ({ id: s.code, text: s.name })) || [] // AI
        } // AI
        this.districtOptions.unshift({ id: 'all', text: 'Tất cả' })
      } catch (error) {
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      } finally {
        this.loadingDictric = false // AI
      } // AI
    },
    // Dữ liệu bảng
    async fetchData () {
      if (!this.loading) this.showLoading = true
      // AI
      try {
        this.loading = true // AI

        if (this.search.level === 'all') delete this.search.level
        if (this.search.cityCode === 'all') delete this.search.cityCode
        if (this.search.districtCode === 'all') delete this.search.districtCode
        if (this.search.managerId === 'all') delete this.search.managerId
        if (this.search.status === 'all') delete this.search.status
        if (this.search.partnerCode === 'all') delete this.search.partnerCode

        const data = await CommonService.getListAgentBank({
          ...this.search,
          sortResultList: [
            {
              field: 'createdDate',
              direction: 'DESC'
            }
          ]
        }) // AI
        if (data.code === 1000) {
          // AI
          this.list = data.data || [] // AI
          this.pagination.total = data?.totalPage?.total ?? 0 // AI
        } else {
          // AI
          this.list = [] // AI
          this.pagination.total = 0 // AI
        } // AI
      } catch (error) {
        // AI
        console.error('Error fetching data:', error) // AI
        this.list = [] // AI
        this.pagination.total = 0 // AI
      } finally {
        // AI
        this.loading = false // AI
        this.showLoading = false // AI
      } // AI
    } // AI
  }
}
</script>
<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.box-search {
  display: flex;
  flex-wrap: wrap;
}

.form-group {
  margin-bottom: 10px;
  min-width: 200px;
}

.form-group-action {
  display: flex;
  align-items: flex-end;
}

.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
permission-list {
  max-height: 400px;
  overflow-y: auto;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.form-check {
  display: flex;
  align-items: center;
  padding: 12px 35px;
  margin-bottom: 8px;
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.form-check:hover {
  background-color: #f1f3f4;
  border-color: #007bff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-check-input {
  width: 20px !important;
  height: 20px !important;
  margin-right: 12px;
  margin-top: 0;
  cursor: pointer;
  border: 2px solid #6c757d;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.form-check-input:checked {
  background-color: #007bff;
  border-color: #007bff;
  transform: scale(1.1);
}

.form-check-input:focus {
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.25);
  border-color: #007bff;
}

.form-check-label {
  font-size: 16px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  line-height: 1.4;
  margin-bottom: 0;
  user-select: none;
  flex: 1;
}

.permission-name {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

/* Style cho modal header */
.modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-bottom: none;
  padding: 20px 25px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
}

/* Style cho modal body */
.modal-body {
  padding: 25px;
  background-color: #ffffff;
}

/* Style cho modal footer */
.modal-footer {
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  padding: 15px 25px;
  justify-content: flex-end;
  gap: 10px;
}

.modal-footer .btn {
  font-size: 14px;
  font-weight: 500;
  padding: 8px 20px;
  border-radius: 5px;
  min-width: 80px;
}

/* Scrollbar styling */
.permission-list::-webkit-scrollbar {
  width: 8px;
}

.permission-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.permission-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.permission-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animation cho checkbox */
@keyframes checkboxPulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.form-check-input:checked {
  animation: checkboxPulse 0.3s ease;
}

/* Responsive */
@media (max-width: 768px) {
  .permission-list {
    max-height: 300px;
    padding: 10px;
  }

  .form-check {
    padding: 10px;
  }

  .form-check-input {
    width: 18px !important;
    height: 18px !important;
  }

  .permission-name {
    font-size: 14px;
  }
}

/* Style cho trạng thái loading */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Hiệu ứng focus cho accessibility */
.form-check:focus-within {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}
</style>
